import { i } from "@instantdb/core";
const schema = i.schema({
    entities: {
        // $files: i.entity({
        //   "content-disposition": i.string().indexed(),
        //   "content-type": i.string().indexed(),
        //   "key-version": i.number(),
        //   metadata: i.string(),
        //   path: i.string().indexed(),
        //   size: i.number().indexed(),
        //   status: i.string().indexed(),
        //   url: i.string(),
        // }),
        $users: i.entity({
            email: i.string().unique().indexed(),
            name: i.string().optional(),
            // Permissions stored directly on user
            admin: i.boolean().optional(),
            editMapStationsNotes: i.boolean().optional(),
            createEditEventInfo: i.boolean().optional(),
            viewWasteData: i.boolean().optional(),
            editWasteData: i.boolean().optional(),
            generateReports: i.boolean().optional(),
            editTodos: i.boolean().optional(),
            completeTodos: i.boolean().optional(),
            viewInventory: i.boolean().optional(),
            manageInventory: i.boolean().optional(),
            editUsers: i.boolean().optional(),
            allowedEventIds: i.string().optional(),
        }),
        userSettings: i.entity({
            eventSortMode: i.string().optional(),
            eventSortDirection: i.string().optional(),
            pinnedEventIds: i.string().optional(),
            pinnedGroupIds: i.string().optional(),
        }),
        /** Single-record app settings (e.g. global welcome doc). Use fixed id from constants. */
        appSettings: i.entity({
            /** Google Doc ID for global welcome screen (embed preview). Admin-only edit. */
            welcomeDocId: i.string().optional(),
            /** Optional tab/sheet id for Google Doc (e.g. ?tab=t.xxx). */
            welcomeTabId: i.string().optional(),
        }),
        signupCodes: i.entity({
            alias: i.string().unique().indexed(),
            permissions: i.json(),
            eventIds: i.string(),
            email: i.string().optional(),
            name: i.string().optional(),
            expiresAt: i.date().indexed(),
            used: i.boolean(),
        }),
        events: i.entity({
            bgImageUrl: i.string().optional(),
            clientLogoUrl: i.string().optional(),
            name: i.string(),
            notes: i.string().optional(),
            order: i.number().optional().indexed(),
            startDate: i.date().optional().indexed(),
            endDate: i.date().optional().indexed(),
            clientName: i.string().optional(),
            location: i.string().optional(),
            /** Google Doc ID for event welcome screen (embed preview). */
            welcomeDocId: i.string().optional(),
            /** Optional tab/sheet id for Google Doc (e.g. ?tab=t.xxx). */
            welcomeTabId: i.string().optional(),
        }),
        todos: i.entity({
            notes: i.string().optional(),
            completed: i.boolean(),
            created_at: i.date().indexed(),
            completed_at: i.date().indexed(),
            areaCoordinates: i.string().optional(), // for sweep
        }),
        latestVersion: i.entity({
            git_commit: i.string(),
        }),
        mapPins: i.entity({
            cleanedUp: i.boolean().optional(),
            notes: i.string().optional(),
            x: i.number(),
            y: i.number(),
        }),
        maps: i.entity({
            bgImageUrl: i.string(),
            name: i.string().optional(),
            order: i.number().indexed(),
        }),
        stationTypes: i.entity({
            black: i.number(),
            blue: i.number(),
            compostBucket: i.number(),
            description: i.string(),
            green: i.number(),
            iconName: i.string(),
            name: i.string(),
            order: i.number().unique().indexed(),
            slimJim: i.number(),
        }),
        todoTypes: i.entity({
            name: i.string(),
            description: i.string(),
            iconName: i.string(),
            order: i.number().unique().indexed(),
            interactionType: i.string(),
            color: i.string(),
            label: i.string().optional(),
        }),
        wasteDatasets: i.entity({
            name: i.string(),
            order: i.number().indexed(),
        }),
        wasteMeasurements: i.entity({
            quantity: i.number(),
            units: i.string(), // Volume | Mass from convert-units, or any material.customUnits[].unit
            timestamp: i.date().indexed(),
        }),
        wasteCategories: i.entity({
            name: i.string(),
            order: i.number().unique().indexed(),
        }),
        wasteMaterials: i.entity({
            name: i.string(),
            order: i.number().indexed(),
            custom: i.boolean(),
            lbsPerYd3: i.number().optional(),
            mtCo2eSavedPerTon: i.number().optional(),
        }),
        wasteMaterialCustomUnits: i.entity({
            unit: i.string(),
            lbsPerUnit: i.number(),
            order: i.number().optional().indexed(),
        }),
        eventGroups: i.entity({
            name: i.string(),
            order: i.number().optional().indexed(),
        }),
        /** View-only share links: one row per secret, linked to event. URL: /viewevent/:eventId/map?secret=... */
        eventViewLinks: i.entity({
            secret: i.string().unique().indexed(),
        }),
        reports: i.entity({
            createdAt: i.date().indexed(),
            materialBreakdown: i.boolean(),
            reportGoogleSlidesId: i.string(),
            chartsGoogleSheetsId: i.string().optional(),
        }),
        reportTemplates: i.entity({
            name: i.string(),
            googleSlidesId: i.string(),
        }),
        chartsSheets: i.entity({
            name: i.string(),
            googleSheetsId: i.string(),
        }),
        chartTemplates: i.entity({
            name: i.string(),
            googleSheetsId: i.string(),
            dataRange: i.string(),
            placeholder: i.string(),
        }),
        charts: i.entity({
            imageURL: i.string(),
            kind: i.string(),
        }),
        itemCategories: i.entity({
            name: i.string().indexed(),
            description: i.string().optional(),
            color: i.string().optional(),
            order: i.number().indexed(),
            systemDefined: i.boolean(),
        }),
        itemTypes: i.entity({
            name: i.string().indexed(),
            description: i.string().optional(),
            photoUrl: i.string().optional(),
            order: i.number().indexed(),
            consumable: i.boolean(),
        }),
        /** Trailer cannot carry this cargo item (normalized: trailer = item in Trailers category). */
        trailerCargoIncompatibilities: i.entity({
            createdAt: i.date().optional().indexed(),
        }),
        storageLocations: i.entity({
            name: i.string().indexed(),
            order: i.number().optional().indexed(),
        }),
        itemLocations: i.entity({
            quantity: i.number().indexed(),
        }),
        packingListItems: i.entity({
            quantity: i.number(),
            confirmed: i.boolean().indexed(),
        }),
        wishListItems: i.entity({
            quantity: i.number(),
        }),
        packingOperations: i.entity({
            createdAt: i.date().indexed(),
            completedAt: i.date().optional().indexed(),
            status: i.string().indexed(),
            notes: i.string().optional(),
        }),
        packingTasks: i.entity({
            quantity: i.number(),
            completed: i.boolean().indexed(),
            completedAt: i.date().optional(),
            ambiguous: i.boolean().indexed(),
        }),
        inventoryHistory: i.entity({
            quantityChange: i.number(),
            type: i.string().indexed(),
            note: i.string().optional(),
            timestamp: i.date().indexed(),
        }),
        trips: i.entity({
            name: i.string().indexed(),
            description: i.string().optional(),
            createdAt: i.date(),
            notes: i.string().optional(),
            /** When the plan was last fully recalculated (not updated on manual supply flow edits). */
            planRecalculatedAt: i.date().optional().indexed(),
            /** Hash of inputs at last recalc; used to detect staleness without marking manual edits as stale. */
            planInputsFingerprint: i.string().optional(),
            /** LP solution as JSON blob: Record<itemTypeId, { A: NodeQuantity[], T: EdgeFlow[] }>. */
            lpSolution: i.json().optional(),
        }),
        tripDagNodes: i.entity({
            index: i.number().indexed(),
            kind: i.string().indexed(),
            eventId: i.string().optional().indexed(),
            storageLocationId: i.string().optional().indexed(),
        }),
        tripDagEdges: i.entity({
            fromNodeIndex: i.number().indexed(),
            toNodeIndex: i.number().indexed(),
        }),
    },
    links: {
        todos: {
            forward: {
                on: "events",
                has: "many",
                label: "todos",
            },
            reverse: {
                on: "todos",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
        },
        todosTodoTypes: {
            forward: {
                on: "todos",
                has: "one",
                label: "todoType",
            },
            reverse: {
                on: "todoTypes",
                has: "many",
                label: "todos",
            },
        },
        todosMapPins: {
            forward: {
                on: "todos",
                has: "one",
                label: "mapPin",
            },
            reverse: {
                on: "mapPins",
                has: "many",
                label: "todos",
            },
        },
        eventsMaps: {
            forward: {
                on: "events",
                has: "many",
                label: "maps",
            },
            reverse: {
                on: "maps",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
        },
        mapPinsStationTypes: {
            forward: {
                on: "mapPins",
                has: "one",
                label: "stationType",
            },
            reverse: {
                on: "stationTypes",
                has: "many",
                label: "mapPins",
            },
        },
        mapsMapPins: {
            forward: {
                on: "maps",
                has: "many",
                label: "pins",
            },
            reverse: {
                on: "mapPins",
                has: "one",
                label: "map",
                onDelete: "cascade",
            },
        },
        wasteMaterialsWasteCategories: {
            forward: {
                on: "wasteMaterials",
                has: "one",
                label: "category",
            },
            reverse: {
                on: "wasteCategories",
                has: "many",
                label: "materials",
            },
        },
        wasteMaterialsEvents: {
            forward: {
                on: "wasteMaterials",
                has: "one",
                label: "forEvent",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "customMaterials",
            },
        },
        wasteMeasurementsWasteMaterials: {
            forward: {
                on: "wasteMeasurements",
                has: "one",
                label: "material",
                onDelete: "cascade",
            },
            reverse: {
                on: "wasteMaterials",
                has: "many",
                label: "measurements",
            },
        },
        wasteMaterialCustomUnitsWasteMaterials: {
            forward: {
                on: "wasteMaterialCustomUnits",
                has: "one",
                label: "material",
                onDelete: "cascade",
            },
            reverse: {
                on: "wasteMaterials",
                has: "many",
                label: "customUnits",
            },
        },
        wasteMeasurementsWasteDatasets: {
            forward: {
                on: "wasteMeasurements",
                has: "one",
                label: "dataset",
                onDelete: "cascade",
            },
            reverse: {
                on: "wasteDatasets",
                has: "many",
                label: "measurements",
            },
        },
        wasteDatasetsEvents: {
            forward: {
                on: "wasteDatasets",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "datasets",
            },
        },
        eventsEventGroups: {
            forward: {
                on: "events",
                has: "one",
                label: "group",
            },
            reverse: {
                on: "eventGroups",
                has: "many",
                label: "events",
            },
        },
        eventViewLinksEvents: {
            forward: {
                on: "eventViewLinks",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "viewLinks",
            },
        },
        reportsEvents: {
            forward: {
                on: "reports",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "reports",
            },
        },
        reportsWasteDatasets: {
            forward: {
                on: "reports",
                has: "many",
                label: "datasets",
            },
            reverse: {
                on: "wasteDatasets",
                has: "many",
                label: "reports",
            },
        },
        reportsWasteMaterials: {
            forward: {
                on: "reports",
                has: "many",
                label: "materials",
            },
            reverse: {
                on: "wasteMaterials",
                has: "many",
                label: "reports",
            },
        },
        reportsWasteCategories: {
            forward: {
                on: "reports",
                has: "many",
                label: "categories",
            },
            reverse: {
                on: "wasteCategories",
                has: "many",
                label: "reports",
            },
        },
        reportsReportTemplates: {
            forward: {
                on: "reports",
                has: "one",
                label: "template",
            },
            reverse: {
                on: "reportTemplates",
                has: "many",
                label: "reports",
            },
        },
        chartsReports: {
            forward: {
                on: "charts",
                has: "one",
                label: "report",
                onDelete: "cascade",
            },
            reverse: {
                on: "reports",
                has: "many",
                label: "charts",
            },
        },
        chartsSheetsReports: {
            forward: {
                on: "chartsSheets",
                has: "one",
                label: "report",
                onDelete: "cascade",
            },
            reverse: {
                on: "reports",
                has: "many",
                label: "chartsSheets",
            },
        },
        chartsSheetsChartsTemplates: {
            forward: {
                on: "chartsSheets",
                has: "many",
                label: "templates",
            },
            reverse: {
                on: "chartTemplates",
                has: "many",
                label: "sheets",
            },
        },
        reportTemplatesChartTemplates: {
            forward: {
                on: "reportTemplates",
                has: "many",
                label: "chartTemplates",
            },
            reverse: {
                on: "chartTemplates",
                has: "many",
                label: "reportTemplates",
            },
        },
        userSettingsUsers: {
            forward: {
                on: "userSettings",
                has: "one",
                label: "user",
            },
            reverse: {
                on: "$users",
                has: "one",
                label: "settings",
            },
        },
        itemTypesItemCategories: {
            forward: {
                on: "itemTypes",
                has: "one",
                label: "category",
            },
            reverse: {
                on: "itemCategories",
                has: "many",
                label: "itemTypes",
            },
        },
        trailerCargoIncompatibilitiesTrailerItemType: {
            forward: {
                on: "trailerCargoIncompatibilities",
                has: "one",
                label: "trailerItemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "trailerCargoIncompatibilitiesAsTrailer",
            },
        },
        trailerCargoIncompatibilitiesCargoItemType: {
            forward: {
                on: "trailerCargoIncompatibilities",
                has: "one",
                label: "cargoItemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "trailerCargoIncompatibilitiesAsCargo",
            },
        },
        itemLocationsItemTypes: {
            forward: {
                on: "itemLocations",
                has: "one",
                label: "itemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "itemLocations",
            },
        },
        itemLocationsEvents: {
            forward: {
                on: "itemLocations",
                has: "one",
                label: "event",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "itemLocations",
            },
        },
        itemLocationsStorageLocations: {
            forward: {
                on: "itemLocations",
                has: "one",
                label: "storageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "itemLocations",
            },
        },
        packingListItemsItemTypes: {
            forward: {
                on: "packingListItems",
                has: "one",
                label: "itemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "packingListItems",
            },
        },
        packingListItemsEvents: {
            forward: {
                on: "packingListItems",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "packingListItems",
            },
        },
        wishListItemsItemTypes: {
            forward: {
                on: "wishListItems",
                has: "one",
                label: "itemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "wishListItems",
            },
        },
        wishListItemsEvents: {
            forward: {
                on: "wishListItems",
                has: "one",
                label: "event",
                onDelete: "cascade",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "wishListItems",
            },
        },
        tripsEvents: {
            forward: {
                on: "trips",
                has: "many",
                label: "events",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "trips",
            },
        },
        tripsPackingOperations: {
            forward: {
                on: "trips",
                has: "many",
                label: "packingOperations",
            },
            reverse: {
                on: "packingOperations",
                has: "one",
                label: "trip",
            },
        },
        tripsSourceStorageLocation: {
            forward: {
                on: "trips",
                has: "one",
                label: "sourceStorageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "sourceTrips",
            },
        },
        tripsDestStorageLocation: {
            forward: {
                on: "trips",
                has: "one",
                label: "destStorageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "destTrips",
            },
        },
        packingOperationsSourceEvents: {
            forward: {
                on: "packingOperations",
                has: "many",
                label: "sourceEvents",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "sourcePackingOperations",
            },
        },
        packingOperationsTargetEvents: {
            forward: {
                on: "packingOperations",
                has: "many",
                label: "targetEvents",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "targetPackingOperations",
            },
        },
        packingOperationsSourceStorageLocations: {
            forward: {
                on: "packingOperations",
                has: "many",
                label: "sourceStorageLocations",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "sourcePackingOperations",
            },
        },
        packingOperationsTargetStorageLocations: {
            forward: {
                on: "packingOperations",
                has: "many",
                label: "targetStorageLocations",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "targetPackingOperations",
            },
        },
        tripDagNodesTrips: {
            forward: {
                on: "tripDagNodes",
                has: "one",
                label: "trip",
                onDelete: "cascade",
            },
            reverse: {
                on: "trips",
                has: "many",
                label: "tripDagNodes",
            },
        },
        tripDagEdgesTrips: {
            forward: {
                on: "tripDagEdges",
                has: "one",
                label: "trip",
                onDelete: "cascade",
            },
            reverse: {
                on: "trips",
                has: "many",
                label: "tripDagEdges",
            },
        },
        packingTasksPackingOperations: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "packingOperation",
                onDelete: "cascade",
            },
            reverse: {
                on: "packingOperations",
                has: "many",
                label: "packingTasks",
            },
        },
        packingTasksItemTypes: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "itemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "packingTasks",
            },
        },
        packingTasksFromEvent: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "fromEvent",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "fromPackingTasks",
            },
        },
        packingTasksToEvent: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "toEvent",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "toPackingTasks",
            },
        },
        packingTasksFromStorageLocation: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "fromStorageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "fromPackingTasks",
            },
        },
        packingTasksToStorageLocation: {
            forward: {
                on: "packingTasks",
                has: "one",
                label: "toStorageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "toPackingTasks",
            },
        },
        inventoryHistoryItemTypes: {
            forward: {
                on: "inventoryHistory",
                has: "one",
                label: "itemType",
            },
            reverse: {
                on: "itemTypes",
                has: "many",
                label: "inventoryHistory",
            },
        },
        inventoryHistoryEvents: {
            forward: {
                on: "inventoryHistory",
                has: "one",
                label: "event",
            },
            reverse: {
                on: "events",
                has: "many",
                label: "inventoryHistory",
            },
        },
        inventoryHistoryStorageLocations: {
            forward: {
                on: "inventoryHistory",
                has: "one",
                label: "storageLocation",
            },
            reverse: {
                on: "storageLocations",
                has: "many",
                label: "inventoryHistory",
            },
        },
    },
    // If you use presence, you can define a room schema here
    // https://www.instantdb.com/docs/presence-and-topics#typesafety
    rooms: {},
});
export default schema;
